/**
 * @file 银联绑定信用卡
 * @date 2020/07/29
 */

import React, {Component} from 'react';
import $ from 'jquery';
import storage from 'store';

class htmlCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            html: ''
        };
    }

    componentDidMount() {
        this.renderHTML();
    }

    renderHTML() {
        let unionHtml = storage.get('htmlcode');
        $('#bank-box').html(unionHtml);
    }

    render() {
        return (
            <div id="bank-box"></div>
        );
    }
}

export default htmlCard;